<template>
    <div>
        <h3 class="font-semibold text-xl mb-4">Please upload the documents and share with us to confirm your status of accredited investor</h3>
        <p class="text-sm mb-4">Please refer the examples of documentation we would expect from you below. Note that the statement(s) should cover the past 12 months in case of income, except for the statements, which are originated periodically (i.e: yearly Tax Declaration report), in which case, the most recent version would be acceptable. The personal and financial asset statement should be not more than 3 months</p>
        <ol class="list-disc ml-8 mb-6">
            <li>Pay slips / Tax declaration</li>
            <li>Bank  statements</li>
            <li>Investment statements</li>
            <li>Investment life policy statement</li>
            <li>Financial statements and business registry excerpt confirming  the value of your shares in private companies</li>
            <li>Excerpt from land / property registry</li>
        </ol>
        <div class="mt-6">
            <vue-dropzone
                style="max-width: 400px; padding: 10px;"
                :options="{...dropzoneOptions, ...{acceptedFiles: '.jpg,.jpeg,.png,.gif,.tiff,.pdf'}}"
                @vdropzone-success="poiFileUploaded"
                @vdropzone-removed-file="poiFileRemoved"
                :useCustomSlot=true
                id="poiFile"
            >
                <div>
                    <div class="font-bold text-primary-500">Maximum 10 documents (Upto 10 MB each)</div>
                    <div class="mt-3 text-sm text-gray-500">Drag & Drop or click here to select files</div>
                    <div class="mst-3 text-sm text-gray-700" v-html="s">
                    </div>
                </div>
            </vue-dropzone>
            <p class="text-sm mb-4">You can upload multiple files by clicking the blank space in the above box</p>
            <div v-if="fieldError('poiFileReference')"
                 class="text-red-500 text-xs italic">
                {{ fieldError('poiFileReference') }}
            </div>
        </div>



        <div class="mt-6">
            <k-button @click.native.prevent="onSubmit" :disabled="submitDisabled">
                {{ $t("submit") }}
            </k-button>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components: {
        vueDropzone: vue2Dropzone
    },
    props: {
        validation: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                poiFileReference:null,
            },
            dropzoneOptions: {
                url: '/api/guest/upload',
                thumbnailWidth: null,
                thumbnailHeight: 200,
                maxFiles: 10,
                maxFilesize: 10,
                addRemoveLinks: true,
                createImageThumbnails: true,
                acceptedFiles: '.jpg,.jpeg,.png,.gif,.tiff,.pdf',
                init: function () {
                    this.on('addedfile', function () {

                    });
                },
            }
        }
    },
    computed: {
        submitDisabled() {
            return !this.form.poiFileReference
        }
    },
    methods: {
        async onSubmit() {
            this.$emit('submit', this.form);
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
        poiFileUploaded(file, response) {
            if(this.form.poiFileReference==null){
                this.form.poiFileReference=[];
            }
            this.form.poiFileReference.push(response.fileReference);
        },
        poiFileRemoved() {
            //this.form.poiFileReference = [];
        }
    }
}
</script>

